import React from "react";
import CheckCircle from '../../elements/icons/CheckCircle';
import PropTypes from 'prop-types';

export default class ListPoint extends React.PureComponent {
    render() {
        let { text, color } = this.props;

        return (
            <div className={'point'}>
                <CheckCircle color={color}/>

                <div className={'text'}>{text}</div>
            </div>
        );
    }
}


ListPoint.propTypes = {
    color: PropTypes.string,
    text: PropTypes.string.isRequired,
};
